/** Promise Finally的polyfill，主要针对chrome<66的移动端内核 */
if (!Promise.prototype.finally) {
    Promise.prototype.finally = function finallyConstructor(callback) {
        var constructor = this.constructor;
        return this.then(function (value) { return constructor.resolve(callback()).then(function () { return value; }); }, function (reason) { return constructor.resolve(callback()).then(function () { return constructor.reject(reason); }); });
    };
}
;
